

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const PrivateRoute = ({ adminOnly = false, children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to login
  if (!user) {
    // Preserve intended destination for non-admin routes so we can redirect after login
    if (!adminOnly) {
      return (
        <Navigate
          to="/login"
          replace
          state={{ from: location }}
        />
      );
    }
    return <Navigate to="/admin/login" replace />;
  }

  // If adminOnly route and user is not admin, redirect to appropriate page
  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  // If regular user tries to access admin route
  if (!adminOnly && user.isAdmin && window.location.pathname.startsWith('/admin')) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;